import { useCallback, useState } from "react";
import type { QrProducto } from "../types/catalogoInventario.types";
import { MAX_QR_POR_LOTE } from "../constants/catalogoInventario.constants";
import { generarQrProductos } from "../utils/catalogoInventarioOperaciones.utils";
import { mensajeResultadoQr } from "../utils/qrProducto.utils";

interface Opciones {
    idUsuario: number;
    onGenerados: (qrs: QrProducto[]) => void;
    onMensaje: (mensaje: string) => void;
    onError: (error: unknown) => void;
}

/** Genera el QR de varios productos a la vez. Regresa true si la petición salió bien. */
export const useGenerarQrMasivo = ({ idUsuario, onGenerados, onMensaje, onError }: Opciones) => {
    const [generando, setGenerando] = useState(false);

    const generar = useCallback(
        async (idsInventario: number[]): Promise<boolean> => {
            if (idsInventario.length === 0) return false;
            if (idsInventario.length > MAX_QR_POR_LOTE) {
                onMensaje(`Solo puedes generar hasta ${MAX_QR_POR_LOTE} QR a la vez.`);
                return false;
            }
            try {
                setGenerando(true);
                const resultado = await generarQrProductos(idsInventario, idUsuario);
                onGenerados([...resultado.generados, ...resultado.existentes]);
                onMensaje(mensajeResultadoQr(resultado));
                return true;
            } catch (error) {
                onError(error);
                return false;
            } finally {
                setGenerando(false);
            }
        },
        [idUsuario, onGenerados, onMensaje, onError]
    );

    return { generar, generando };
};
